// import qs from 'qs';
import cloneDeep from 'lodash/cloneDeep';

import { fulfillmentUrl } from 'utils/wrappers';
import Base from 'app/models/base';

let warehouseCache = {};

export default Base.extend({
  urlRoot: fulfillmentUrl('products'),

  parse(attributes) {
    return { rawJSON: cloneDeep(attributes), ...attributes };
  },

  /* eslint consistent-return: 0 */
  count() {
    let inventories = this.get('inventories');
    if (!inventories) { return 0; }

    inventories = inventories.get('inventory');

    return Object.keys(inventories).reduce((count, id) => {
      return count + inventories[id];
    }, 0);
  },

  getInventory(id) {
    let inventories = this.get('inventories');

    if (!inventories) {
      return {};
    }

    inventories = inventories.get('inventory');

    let inventory = Object.keys(inventories).reduce((obj, wid) => ({
      ...obj,
      [wid]: {
        inventory: inventories[wid],
        city: (warehouseCache[wid] || {}).city,
        state: (warehouseCache[wid] || {}).state,
      },
    }), {});

    if (id) { return inventory[id]; }
    return inventory;
  },

  async fetchWarehouses() {
    let inventories = this.get('inventories');

    if (!inventories) {
      this.on('change:inventories', this.fetchWarehouses);
      return {};
    }

    inventories = inventories.get('inventory');

    // if we already have the warehouses, no need to re-request
    if (this.get('warehousesLoaded')) {
      return inventories;
    }

    // if we already loaded warehouse info for any of the warehouses we have,
    // no need to request it again
    let warehouses = Object.keys(inventories).reduce((obj, wid) => {
      if (!warehouseCache[wid]) {
        return obj;
      }

      return { ...obj,  [wid]: warehouseCache[wid] };
    }, {});

    // check any warehouses we haven't already loaded, so we can load them
    const unloadedIds = Object.keys(inventories).filter(id => !warehouses[id]);

    if (unloadedIds.length > 0) {
      const loadedWarehouses = unloadedIds.reduce((o, id) => ({
        ...o,
        [id]: {
          city: 'San Leandro',
          state: 'CA',
        },
      }), {});
      /*
      unloadedIds.forEach(id => warehouseCache[id] = { loading: true });

      // This API endpoint doesn't exist yet - hardcoding per Tribone.
      const loadedWarehouses = await Promise.resolve((r) => {
        const querystring = qs.stringify({ id: unloadedIds });
        const warehousesUrl = fulfillmentUrl(`warehouses?${querystring}`);
        $.get(warehousesUrl, r);
      });
      */

      // request the warehouses we don't have yet
      warehouses = {
        ...warehouses,
        ...loadedWarehouses,
      };

      // put the loaded warehouses into the cache
      warehouseCache = { ...warehouseCache, ...warehouses };
      this.set({ warehousesLoaded: true });
      return warehouses;
    }

    return warehouses;
  },
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_product.js